export { default } from './IntegrationsManager.vue'
